// extracted by mini-css-extract-plugin
export var explainable = "_gm-a";
export var printerCard = "_gm-1";
export var printerCardConfigured = "_gm-2";
export var printerCardError = "_gm-3";
export var printerCardsContainer = "_gm-0";
export var printerIcon = "_gm-8";
export var printerIconConfigured = "_gm-5";
export var printerIconContainer = "_gm-4";
export var printerIconError = "_gm-6";
export var printerIconUnconfigured = "_gm-7";
export var workstationsTableCard = "_gm-9";